<script lang="ts">
    import MainLayout from "../#common/layout/Layout.svelte"
    import SellerIntro from 'src/components/main/marketplace-seller/components/seller-intro/SellerIntro.svelte'
    import NftCards from 'src/components/main/marketplace-seller/components/nft-cards/NftCards.svelte'
    import VisitCommunity from 'src/components/main/#common/visit-community/VisitCommunity.svelte'
    import {getNickname} from 'src/components/main/#services/account'

    export let userId

    getNickname.send({ data: { userId } })
</script>

<svelte:head>
    {#if !$getNickname.hasValue && $getNickname.loading}
        <title>Loading...</title>
    {:else if !$getNickname.hasValue && $getNickname.error}
        <title>Something went wrong</title>
    {:else if $getNickname.hasValue}
        <title>{$getNickname.value.replace(/#([^#]+)$/, '')}</title>
    {/if}
    <meta name="description" content=""/>
</svelte:head>

<MainLayout>
    <svelte:fragment slot="content">
        <SellerIntro {userId}/>
        <NftCards {userId}/>
        <!--<VisitCommunity/>-->
    </svelte:fragment>
</MainLayout>
